import React, { useContext } from "react";
import { Link, useLoaderData } from "react-router-dom";
import { AuthContext } from "../../Context/AuthProvider/AuthProvider";
import Spinner from "../../Shared/Spinner/Spinner";
import Banner from "./Banner";
import CategoryNav from "./CategoryNav";
import InformationContent from "./InformationContent";
import Newsletter from "./Newsletter";
import Services from "./Services";

const Home = () => {
  const services = useLoaderData();

  const { loading, setLoading } = useContext(AuthContext);
  if (loading) {
    return <Spinner></Spinner>;
  }

  return (
    <div>
      <CategoryNav></CategoryNav>
      <Banner></Banner>
      <Services></Services>
      <Link to="/services">
        <button className="btn btn-outline mx-auto block my-10">View All Services</button>
      </Link>
      <InformationContent></InformationContent>
      <Newsletter></Newsletter>
    </div>
  );
};

export default Home;
